var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-button',{staticClass:"ctk-list-filters-items-item px-3 dots-text",attrs:{"variant":_vm.active ? 'info' : 'link'},on:{"click":_vm.click}},[_c('div',{staticClass:"tw-flex tw-items-center"},[_c('ui-material-icon',{staticClass:"mr-1",attrs:{"name":_vm.active
        ? _vm.multiple
          ? 'check_box'
          : 'radio_button_checked'
        : _vm.multiple
          ? 'check_box_outline_blank'
          : 'radio_button_unchecked'}}),_c('span',{staticClass:"dots-text"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }